import fetch from 'node-fetch';

export const sendError = (error, componentStack, state) => {
  const errorData = error ? error.stack.toString() : '';
  fetch('/errorlog', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({ error: errorData, componentStack, state }),
  });
};
